import React from 'react';

export function VeryDissatisfiedFace({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="2" />
      <circle cx="13" cy="16" r="2" fill="currentColor" />
      <circle cx="27" cy="16" r="2" fill="currentColor" />
      <path d="M12 29 Q20 21 28 29" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export function DissatisfiedFace({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="2" />
      <circle cx="13" cy="16" r="2" fill="currentColor" />
      <circle cx="27" cy="16" r="2" fill="currentColor" />
      <path d="M13 27 Q20 24 27 27" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export function SatisfiedFace({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="2" />
      <circle cx="13" cy="16" r="2" fill="currentColor" />
      <circle cx="27" cy="16" r="2" fill="currentColor" />
      <path d="M13 24 Q20 29 27 24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export function VerySatisfiedFace({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="2" />
      <path d="M11 15 Q13 12 15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M25 15 Q27 12 29 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M11 24 Q20 33 29 24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export const CheckSVG = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
    stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);
